import { error } from '@utils/logger'
import { apiFetch } from '@utils/fetch'

export interface ClearVenueCacheRequest {
  tenant_ref: string
  venue_ref: string
}

export interface ClearVenueCacheResponse {
  status: string
  message: string
}

export async function clearVenueCache(request: ClearVenueCacheRequest): Promise<ClearVenueCacheResponse | null> {
  try {
    const resp = await apiFetch('/api/admin/venues/cache/clear', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(request)
    })

    if (!resp.ok) {
      error('failed to clear venue cache', resp.statusText)
      return null
    }

    const data = await resp.json()
    return data as ClearVenueCacheResponse
  } catch (err) {
    error('failed to clear venue cache', err)
    return null
  }
}

export default { clearVenueCache }